import { render, staticRenderFns } from "./CardsCarousel.vue?vue&type=template&id=7446ecd8&scoped=true"
import script from "./CardsCarousel.vue?vue&type=script&lang=js"
export * from "./CardsCarousel.vue?vue&type=script&lang=js"
import style0 from "./CardsCarousel.vue?vue&type=style&index=0&id=7446ecd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7446ecd8",
  null
  
)

export default component.exports